import {
  configure,
  action,
  makeObservable,
  observable,
} from 'mobx';

class UserStore {
  constructor() {
    this.token = null;
    this.valueGuidePlusReport = null;
    this.valueGuideProReport = null;

    makeObservable(this, {
      token: observable,
      valueGuidePlusReport: observable,
      valueGuideProReport: observable,
      setToken: action,
      setValueGuideProReport: action,
      setValueGuidePlusReport: action,
    });
  }

  setToken(token) {
    this.token = token;
  }

  setValueGuideProReport = (value) => {
    this.valueGuideProReport = value;
  };

  setValueGuidePlusReport = (value) => {
    this.valueGuidePlusReport = value;
  };
}

export default UserStore;
